import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, useHistory } from 'react-router-dom';
import { Card, CardBody, CardTitle, Col, Container, Label, Row, Button, Form, FormGroup, Input } from 'reactstrap';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import Template from '../Templates/Home';
import Title from '../PolicyDetails/Title';
import Loading from '../UI/Loading';

const ProviderPreApproval = ({ data, policyData, loading, users, getProviderPreApproval }) => {
  //   const { register, setValue, getValues, reset } = useForm();
  // const ProviderPreApproval = ({ data, policyData, loading }) => {
  const { register, setValue, reset } = useForm();
  const [minDate, setMinDate] = useState(null);
  const maxDate = moment().format('YYYY-MM-DD');

  const history = useHistory();
  const breadcrumb = [
    { label: 'Dashboard', to: '/home' },
    { label: 'Policy Details', to: '/home/policyDetails' },
    { label: 'Services', to: '/home/services' },
    { label: 'Provider PreApproval', active: true },
  ];
  const [payload, setPayload] = useState({});

  return (
    <Template pageTitle="Provider PreApproval" breadcrumb={breadcrumb}>
      <>
        <Container fluid className="max-container">
          <Fragment>
            <Title
              policyNumber={policyData?.policyNumber}
              certificateNumber={policyData?.certificateNumber}
              expiryDate={policyData?.expiryDate}
              type={policyData.type}
            />
          </Fragment>
          <Form>
            <Row className="search-filter">
              <Col>
                <FormGroup className="form-label-group">
                  <Input
                    type="select"
                    innerRef={register()}
                    onChange={(element) => {
                      // setValue('dependent_id', e.target.value);
                      const filteredUserData = users?.filter(
                        (e) => e?.id.toString() === element.target.value.toString(),
                      );
                      // setUserData(filteredUserData[0]);
                      console.log('FILTER USERS ', filteredUserData);
                      if (filteredUserData[0]?.dependent_id) {
                        setPayload({ ...payload, dID: filteredUserData[0]?.dependent_id });
                      } else {
                        setPayload({});
                      }
                    }}
                    name="user_id"
                    id="user_id"
                  >
                    {users?.map((item) => (
                      <option key={item?.id} value={item?.id} selected={item?.is_principal}>
                        {item?.member_name}
                      </option>
                    ))}
                  </Input>
                  <Label>Patient</Label>
                </FormGroup>
              </Col>
              {/* <Col>
                  <FormGroup className="form-label-group">
                    <Input
                      innerRef={register()}
                      onChange={(e) => setValue('status', e.target.value)}
                      type="select"
                      name="status"
                      defaultValue=""
                      id="status"
                    >
                      <option value="">All</option>
                      <option value="-1">Submitted</option>
                      <option value="0">In Progress</option>
                      <option value="1">Approved</option>
                      <option value="2">Rejected</option>
                      <option value="3">Partially Approved</option>
                      <option value="5">Re-Submitted</option>
                      <option value="6">Suspended</option>
                      <option value="4">Draft</option>
                    </Input>
                    <Label>Status</Label>
                  </FormGroup>
                </Col> */}
              <Col>
                <FormGroup className="form-label-group">
                  <Input
                    name="from_date"
                    innerRef={register()}
                    onChange={(e) => {
                      setValue('from_date', e.target.value);
                      setMinDate(moment(e.target.value).format('YYYY-MM-DD'));
                      setPayload({ ...payload, from_date: e.target.value });
                    }}
                    type="text"
                    max={maxDate}
                    onFocus={(e) => {
                      e.target.type = 'date';
                    }}
                    placeholder="Date From"
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = 'text';
                    }}
                  />
                  <Label>Date From</Label>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="form-label-group">
                  <Input
                    name="to_date"
                    innerRef={register()}
                    onChange={(e) => {
                      setValue('to_date', e.target.value);
                      setPayload({ ...payload, to_date: e.target.value });
                    }}
                    placeholder="Date To"
                    type="text"
                    min={minDate}
                    max={maxDate}
                    onFocus={(e) => {
                      e.target.type = 'date';
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = 'text';
                    }}
                  />
                  <Label>Date To</Label>
                </FormGroup>
              </Col>
              <Col className="text-right">
                <Button
                  className="reset mr-3"
                  onClick={() => {
                    reset();
                    setPayload({});
                    getProviderPreApproval();
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 4C9.69818 4 7.62561 5.02187 6.19328 6.65856C5.82957 7.07417 5.1978 7.11624 4.78219 6.75253C4.36658 6.38881 4.32451 5.75705 4.68823 5.34144C6.47858 3.29564 9.08928 2 12 2C17.3671 2 21.6932 6.38925 21.7981 11.7989L22.285 11.3009C22.6711 10.906 23.3042 10.8989 23.6991 11.285C24.094 11.6711 24.1011 12.3042 23.715 12.6991L21.515 14.9491C21.3269 15.1415 21.0691 15.25 20.8 15.25C20.5309 15.25 20.2731 15.1415 20.085 14.9491L17.885 12.6991C17.4989 12.3042 17.506 11.6711 17.9009 11.285C18.2958 10.8989 18.9289 10.906 19.315 11.3009L19.7975 11.7943C19.691 7.45096 16.2203 4 12 4ZM3.2 8.75C3.46911 8.75 3.72687 8.85847 3.91501 9.05088L6.11501 11.3009C6.50112 11.6958 6.49401 12.3289 6.09912 12.715C5.70423 13.1011 5.07111 13.094 4.68499 12.6991L4.20252 12.2057C4.30903 16.549 7.77965 20 12 20C14.3018 20 16.3744 18.9781 17.8067 17.3414C18.1704 16.9258 18.8022 16.8838 19.2178 17.2475C19.6334 17.6112 19.6755 18.243 19.3118 18.6586C17.5214 20.7044 14.9107 22 12 22C6.6329 22 2.30681 17.6107 2.20195 12.2011L1.71501 12.6991C1.3289 13.094 0.69577 13.1011 0.300883 12.715C-0.0940045 12.3289 -0.101118 11.6958 0.284994 11.3009L2.48499 9.05088C2.67313 8.85847 2.93089 8.75 3.2 8.75Z"
                        fill="#293644"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </Button>
                <Button
                  className="search-provider"
                  onClick={() => {
                    getProviderPreApproval(payload);
                  }}
                >
                  <svg id="Icon-Search" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
                    <path
                      id="Icon_Search"
                      data-name="Icon/Search"
                      d="M18.752,21h0L21,18.795l-6.033-5.916a7.956,7.956,0,0,0,.67-8.452A8.331,8.331,0,0,0,.466,5.433,8.036,8.036,0,0,0,3.1,14.458a8.4,8.4,0,0,0,9.551.555L18.751,21ZM8.27,3.118a5.058,5.058,0,0,1,5.1,5,5.1,5.1,0,0,1-10.2,0A5.058,5.058,0,0,1,8.27,3.118Z"
                      transform="translate(5 5)"
                      fill="#fff"
                    />
                  </svg>
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
        <section className="metLife-gray">
          <Container fluid className="max-container">
            <Row>
              {loading ? (
                <Loading />
              ) : data.length ? (
                data?.map((item) => (
                  <Col className="col-12 mb-4" md="6">
                    <Card className="pointer height-adj h-100">
                      <CardBody>
                        <Row
                          className="d-flex justify-content-between claim-list-item"
                          onClick={() => {
                            history.push({
                              pathname: '/home/providerPreApprovalDetails',
                              state: { data: item },
                            });
                          }}
                        >
                          <Col className="info-list-wrapper" md="12">
                            <div className="info-list list-unstyled">
                              {/* <li>{`Claim #:${data?.id}`}</li>
              <li>{`Insured Name :${data?.payable}`}</li>
              <li>{`Claimed Amount :${data?.claim_type}`}</li>
              <li>{`Submission Date: ${data?.scheduled_to_pay}`}</li>
              <li>{`Claim Type: ${data?.claim_type}`}</li> */}

                              <Row className="mx-0 align-items-center mb-1">
                                <Label className="pr-2">Pre-Approval #: </Label>
                                <h4>{item?.authorization_reference_string}</h4>
                              </Row>
                              <Row className="mx-0 align-items-center mb-1">
                                <Label className="pr-2">Submission Date: </Label>
                                <h4>{moment(item?.submit_date).format('DD-MM-YYYY')}</h4>
                              </Row>
                              <Row className="mx-0 mb-1 flex-nowrap">
                                <Label className="pr-2 text-nowrap">Hospital Name: </Label>
                                <h4 className="text-left">{item?.hospital}</h4>
                              </Row>
                              <Row className="mx-0 align-items-center mt-3">
                                <h4 className="border py-1 px-3 rounded-lg my-1">{item?.status}</h4>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              ) : (
                <div className="no-results mt-3">
                  <Card
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <CardBody className="pt-4">
                      <CardTitle tag="h5">No Provider Pre-Approvals</CardTitle>
                    </CardBody>
                  </Card>
                </div>
              )}
            </Row>
          </Container>
        </section>
      </>
    </Template>
  );
};

ProviderPreApproval.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
  loading: PropTypes.bool,
  policyData: PropTypes.shape({
    type: PropTypes.number,
    policyNumber: PropTypes.number,
    certificateNumber: PropTypes.string,
    expiryDate: PropTypes.string,
    dependents: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        member_name: PropTypes.string,
      }),
    ),
    member_details: PropTypes.shape({
      member_name: PropTypes.string,
    }),
  }).isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  user: PropTypes.shape({
    card_number: PropTypes.string,
    id: PropTypes.number,
    dependent_id: PropTypes.number,
    is_principal: PropTypes.bool.isRequired,
  }).isRequired,
  getProviderPreApproval: PropTypes.func.isRequired,
};

ProviderPreApproval.defaultProps = {
  data: [],
  loading: false,
};

export default withRouter(ProviderPreApproval);
